import * as React from 'react'
import { Table, Empty } from 'antd'
import { FormattedMessage } from 'react-intl'
import { OptionalAmount } from '../Amount'
import { InvoiceItem } from '../../types'

type Props = {
  items: InvoiceItem[]
  unitID?: string
}

export const ShowInvoiceItems = ({ items, unitID }: Props) => (
  <Table<InvoiceItem>
    dataSource={items ?? []}
    locale={{
      emptyText: (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={<FormattedMessage id="noItems" />}
        />
      ),
    }}
    columns={[
      {
        dataIndex: 'name',
        title: <FormattedMessage id="name" />,
        width: '199px',
        render: (_, v) => v.item.name,
      },
      {
        dataIndex: 'price',
        title: <FormattedMessage id="price" />,
        render: (_, i) => {
          return <OptionalAmount unit={unitID} amount={i.item.price} />
        },
      },
      {
        dataIndex: 'quantity',
        title: <FormattedMessage id="quantity" />,
        render: (_, item) => item.quantity,
      },
      {
        dataIndex: 'total',
        title: <FormattedMessage id="total" />,
        render: (_, i) => (
          <OptionalAmount
            unit={unitID}
            amount={i.item.price}
            map={x => x * i.quantity}
          />
        ),
      },
    ]}
    pagination={false}
    size="small"
    bordered={false}
  />
)
